import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent {
  title: any;
  headingText: any;
  bodyText: any;
  footerText: any;

  readonly CONSTANTS = CONSTANTS;
  readonly LANG_CONST = LANG_CONST;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.headingText = data.headingText;
    this.title = data.title;
    this.bodyText = data.bodyText;
    this.footerText = data.footerText;
  }

  acceptDialog() {
    this.dialogRef.close(true);
  }

  rejectDialog() {
    this.dialogRef.close(false);
  }
}
